import {
  Accordion,
  ActionIcon,
  Box,
  Checkbox,
  Flex,
  Text,
  type AccordionControlProps,
} from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Badge } from '@flecto/ui'
import localizeDayName from '@flecto/utils/src/Date/localizeDayName'
import { type DayOfWeek } from '@flecto/utils/src/Date/ScheduleHours'

import { useBusinessHour } from './BusinessHoursProvider'

interface AccordionHoursProps extends AccordionControlProps {
  isOpened?: boolean
  day: DayOfWeek
}

export function AccordionControl({
  day,
  isOpened = false,
  ...props
}: AccordionHoursProps) {
  const {
    i18n: { language },
  } = useTranslation()
  const { checked, setChecked, getRangeLabel } = useBusinessHour()
  const { t } = useTranslation('saas', { keyPrefix: 'general' })

  return (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <ActionIcon
        size='lg'
        unstyled
        bg='transparent'
        style={{ border: 'none' }}
      >
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.currentTarget.checked)}
        />
      </ActionIcon>
      <Accordion.Control {...props} p={0}>
        <Flex align='center' justify='space-between' pr='sm'>
          <Box>{localizeDayName(day, language)}</Box>
          {checked && !isOpened && <Text>{getRangeLabel()}</Text>}
          {!checked && !isOpened && <Badge>{t('closed')}</Badge>}
        </Flex>
      </Accordion.Control>
    </Box>
  )
}
